<div *ngIf="finished==false" class='text-center'>
  <svg width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling"
    style="background: none;">
    <circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
        keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>
  </svg>
</div>

<div *ngIf="no_recfound" class="text-center">
  {{mls?.languageText?.feed?.key1}}<span *ngIf="mls?.is_lskey_display==1">(feed.key1)</span>
</div>


<div *ngIf="is_res_received && no_recfound==false" class="row m-0 mb-5 mb-md-0 cursor-pointer" (click)="navigateto()"
  [eventTracker]='{"category":"web_share","action":"click_on_feed","product_type":product_type,"product_id":product_type_id}'>

  <div class="pr-0 pl-0 new-modal-cody-remove-pading col-12">

    <div id="product_detail_div_for_scroll" class="ps position-relative fnt-size14px modal-cmmnt-bg">
      <div class="modal-body p-0">

        <div class="bg-white pb-2 rounded-top">
          <!-- comment card -->
          <div class="border-bottom p-2 ">

            <div class="cnnction-rqst ">
              <div class="row">
                <div class="col-10">
                  <div class="clearfix">
                    <div class="float-left mr-2 cursor-pointer connection-profile">
                      <div class="position-relative">
                        <img *ngIf="feed_detail?.user_profile!=null"
                          class="c-profile-pic rounded-circle user-40 post-pic"
                          onerror="this.src='assets/img/user_placeholder.svg'"
                          src={{feed_detail?.user_profile?.profile_pic}}>

                        <img *ngIf="feed_detail?.channel!=null" class="c-profile-pic rounded-circle user-40 post-pic"
                          onerror="this.src='assets/img/user_placeholder.svg'"
                          src={{feed_detail?.channel?.channel_logo}}>


                        <div *ngIf="feed_detail?.user_profile!=null" class="position-absolute profile-badge "><svg
                            viewBox="0 0 10 10" class="">
                            <defs>
                              <style>
                                .verified-profile {
                                  fill: #65c194;
                                }

                                .verified-profile-2 {
                                  fill: #fff;
                                }

                                .verified-profile-3 {
                                  fill: #65c194;
                                }
                              </style>
                            </defs>
                            <title>Artboard 52</title>
                            <g data-name="Layer 3" id="Layer_3">
                              <path class="verified-profile"
                                d="M5,9.25a.49.49,0,0,1-.32-.1,6.17,6.17,0,0,1-2-1.72,7.68,7.68,0,0,1-1.46-5,.57.57,0,0,1,.51-.53,8.79,8.79,0,0,0,1.46-.34A10.9,10.9,0,0,0,4.72.82a.6.6,0,0,1,.56,0,11.6,11.6,0,0,0,1.59.71,6.63,6.63,0,0,0,1.46.33.56.56,0,0,1,.5.55,7.66,7.66,0,0,1-1.45,5A6.56,6.56,0,0,1,5.29,9.18.68.68,0,0,1,5,9.25Z">
                              </path>
                              <path class="verified-profile-2"
                                d="M5,1a.32.32,0,0,1,.16,0,12.37,12.37,0,0,0,1.63.72,6.91,6.91,0,0,0,1.51.35.31.31,0,0,1,.28.3,7.44,7.44,0,0,1-1.4,4.87A6.3,6.3,0,0,1,5.18,9,.58.58,0,0,1,5,9a.27.27,0,0,1-.16,0,6.21,6.21,0,0,1-2-1.68A7.46,7.46,0,0,1,1.42,2.4a.33.33,0,0,1,.29-.3,7.05,7.05,0,0,0,1.51-.35A11,11,0,0,0,4.84,1,.32.32,0,0,1,5,1M5,.5a.82.82,0,0,0-.4.1,10.34,10.34,0,0,1-1.54.68,7.29,7.29,0,0,1-1.42.33.83.83,0,0,0-.72.74A8,8,0,0,0,2.43,7.58,6.75,6.75,0,0,0,4.58,9.39.77.77,0,0,0,5,9.5a1,1,0,0,0,.37-.08A7.08,7.08,0,0,0,7.58,7.59a7.93,7.93,0,0,0,1.5-5.2.81.81,0,0,0-.73-.78A6.72,6.72,0,0,1,7,1.29,11.75,11.75,0,0,1,5.39.6.76.76,0,0,0,5,.5Z">
                              </path>
                              <path class="verified-profile-3"
                                d="M8.58,2.41a.31.31,0,0,0-.28-.3,6.91,6.91,0,0,1-1.51-.35A12.37,12.37,0,0,1,5.16,1,.42.42,0,0,0,5,1V9a.58.58,0,0,0,.18,0,6.3,6.3,0,0,0,2-1.68A7.44,7.44,0,0,0,8.58,2.41Z">
                              </path>
                              <path class="verified-profile-2"
                                d="M4.43,5.9a.31.31,0,0,1-.22-.09l-.74-.74a.32.32,0,0,1,.45-.45l.51.51L6.21,3.36a.31.31,0,0,1,.45,0,.33.33,0,0,1,0,.45l-2,2A.32.32,0,0,1,4.43,5.9Z">
                              </path>
                            </g>
                          </svg></div>
                      </div>
                    </div>
                    <div class="float-left pl-0 cursor-pointer d-table mw-80" style="min-height: 45px;">
                      <div style=" display: table-cell;vertical-align: middle;">
                        <p class="text-capitalize fnt-size14px">
                          <b>{{feed_detail?.user_profile?.full_name || feed_detail?.channel?.title}}<span></span></b>
                          <!--

  }-->
                        </p>
                        <p class="fnt-size12px ">
                          <span class="connection-speciality" *ngFor="let spe of feed_detail?.user_profile?.specialities">
                            {{(spe?.is_primary==1)? spe?.speciality_name:''}}

                          </span></p>
                        <!--

  }-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--

  }-->
          </div>
          <!-- single media -->
          <span *ngIf="feed_detail?.channel?.pharma_classification!='pharma'">

            <div *ngIf="feed_detail?.media_list.length==1" class="single_image ">
              <div class="img-relative"><a class="singleimg-link " href="javascript:void(0);">
                  <img
                    *ngIf="feed_detail?.media_list[0].media_type=='video'  ||  feed_detail?.media_list[0].media_type=='document'  "
                    src={{feed_detail?.media_list[0].media_thumbnail}}
                    onerror="this.src='assets/img/image_placeholder.svg'">
                  <img *ngIf="feed_detail?.media_list[0].media_type=='image'  "
                    src={{feed_detail?.media_list[0].media_url}} onerror="this.src='assets/img/image_placeholder.svg'">

                    <img *ngIf="feed_detail?.media_list[0].media_type=='audio'  "
                    src='' onerror="this.src='assets/img/audio.png'">
                </a>
              </div>

            </div>
            <!-- double media  -->
            <div class="d-block" *ngIf="feed_detail?.media_list.length==2">
              <div class="mip-left d-inline-block">
                <div class="img-relative">
                  <a class="img-link">
                    <img
                      *ngIf="feed_detail?.media_list[0].media_type=='video'  ||  feed_detail?.media_list[0].media_type=='document'  "
                      src={{feed_detail?.media_list[0].media_thumbnail}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                    <img *ngIf="feed_detail?.media_list[0].media_type=='image'  "
                      src={{feed_detail?.media_list[0].media_url}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                  </a>
                </div>
              </div>
              <div class="mip-right d-inline-block">
                <div class="img-relative multipleImageTH">
                  <a class="img-link" href="javascript:void(0);">
                    <img
                      *ngIf="feed_detail?.media_list[1].media_type=='video'  ||  feed_detail?.media_list[1].media_type=='document'  "
                      src={{feed_detail?.media_list[1].media_thumbnail}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                    <img *ngIf="feed_detail?.media_list[1].media_type=='image'  "
                      src={{feed_detail?.media_list[1].media_url}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                  </a>
                </div>
              </div>
            </div>
            <!-- multiple media -->
            <div class="d-block " *ngIf="feed_detail?.media_list.length > 2">
              <div class="mip-left d-inline-block">
                <div class="img-relative"><a class="img-link">
                    <img
                      *ngIf="feed_detail?.media_list[0].media_type=='video'  ||  feed_detail?.media_list[0].media_type=='document'  "
                      src={{feed_detail?.media_list[0].media_thumbnail}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                    <img *ngIf="feed_detail?.media_list[0].media_type=='image'  "
                      src={{feed_detail?.media_list[0].media_url}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                  </a></div>
              </div>
              <div class="mip-right d-inline-block multipleImage-right">
                <div class="img-relative"><a class="img-link">
                    <img
                      *ngIf="feed_detail?.media_list[1].media_type=='video'  ||  feed_detail?.media_list[1].media_type=='document'  "
                      src={{feed_detail?.media_list[1].media_thumbnail}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                    <img *ngIf="feed_detail?.media_list[1].media_type=='image'  "
                      src={{feed_detail?.media_list[1].media_url}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                  </a></div>
                <div class="img-relative position-relative">
                  <a class="img-link">
                    <img
                      *ngIf="feed_detail?.media_list[2].media_type=='video'  ||  feed_detail?.media_list[2].media_type=='document'  "
                      src={{feed_detail?.media_list[2].media_thumbnail}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                    <img *ngIf="feed_detail?.media_list[2].media_type=='image'  "
                      src={{feed_detail?.media_list[2].media_url}}
                      onerror="this.src='assets/img/image_placeholder.svg'">
                  </a>
                  <div *ngIf="feed_detail?.media_list.length > 3" class="position-absolute w-100 h-100 text-center"
                    style="z-index: 1; background-color: rgba(0, 0, 0, 0.5); top: 0;
      left: 0; color: #fff;">
                    <p class="center-text position-absolute">+{{3-feed_detail?.media_list.length}}
                      {{mls?.languageText?.feed?.key2}}<span *ngIf="mls?.is_lskey_display==1">(feed.key2)</span></p>
                  </div>
                </div>
              </div>
            </div>


            <!-- title -->
            <div class="position-relative  mb-2 new-modal-content">
              <h5 class="title_Case">{{feed_detail?.title}}</h5>

              <div class="p-2 ">
                <p style="display:inline;" class="userPostText">{{feed_detail?.content}}</p>

                <!-- new poll design -->
                <div *ngIf="feed_detail?.feed_kind =='poll'" class="poll-post mt-2">
                  <ul class="m-0">
                    <!-- without selected -->
                    <li *ngFor="let feedpoll of feed_detail?.poll "
                      class="p-2 border rounded mb-2 cursor-pointer position-relative">
                      <!-- without image-->
                      <div class="position-relative" style="z-index: 1;">
                        <div class="clearfix">
                          <!-- <div class="opt-img float-left mr-2 rounded">
                               <img src=""   onerror="this.src='assets/img/image_placeholder.svg'"/>
                       </div> -->
                          <div class="text-center text-success">
                            <span class="fnt-size14px fnt-weight500">{{feedpoll?.options}}</span>
                          </div>
                        </div>
                      </div>
                      <!-- percentage bar -->
                      <!-- <div class="position-absolute bg-light-grey-color h-100 rounded" style="left:0; top:0; width: 60%" ></div> -->
                    </li>
                  </ul>
                </div>
              </div>
              <!-- end new poll  -->
              <div class="post-tags pl-2 pr-2">
                <span class="mr-2 cursor-pointer">
                  <b *ngFor="let allSpeciality of feed_detail?.speciality">#{{allSpeciality.speciality_name}}</b>
                </span>
              </div>
            </div>


            <div class="new-modal-like-comment-count border-top p-2 border-bottom"
              *ngIf="(feed_detail?.total_like > 0 || feed_detail?.total_comments > 0 )">

              <p class="clearfix fnt-size12px">
                <span
                  *ngIf="(feed_detail?.total_like !='' || feed_detail?.total_like !=null) && feed_detail?.total_like > 0 "
                  class="new-modal-like-comment float-left cursor-pointer">{{feed_detail?.total_like}}
                  {{mls?.languageText?.feed?.key3}}<span *ngIf="mls?.is_lskey_display==1">(feed.key3)</span> </span>

                <span
                  *ngIf="(feed_detail?.total_comments !='' || feed_detail?.total_comments !=null) && feed_detail?.total_comments > 0 "
                  class="float-right new-modal-like-comment">{{feed_detail?.total_comments}}
                  {{mls?.languageText?.feed?.key4}}<span *ngIf="mls?.is_lskey_display==1">(feed.key4)</span></span></p>
            </div>

            <div class="new-modal-like-comment-icon pt-2">
              <div class=" row">
                <div class="like col-4 text-center">
                  <span class="cursor-pointer">

                    <!-- <svg *ngIf="feed_like_loader==true" width="20px"  height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling" style="background: none;"><circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg> -->

                    <svg width="20px" id="Layer_1" data-name="Layer 1" viewBox="0 0 22 22">
                      <defs>
                        <style>
                          .cls-lyk1-right {
                            fill: none;
                            stroke: #747475;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                          }
                        </style>
                      </defs>
                      <path class="cls-lyk1-right"
                        d="M7.23,16.92H8l.69.73a2.51,2.51,0,0,0,1.78.79L15,18.5a2.15,2.15,0,0,0,2.1-1.65A1.6,1.6,0,0,0,17,15.8s1.62-1.62.54-3a1.38,1.38,0,0,0,1.05-1.41A2.33,2.33,0,0,0,16.19,9H12.91V6.55A3.15,3.15,0,0,0,11,3.64l-.18-.08a.82.82,0,0,0-1.13.75V6.46a1.62,1.62,0,0,1-.2.78L8.47,9A.56.56,0,0,1,8,9.31H7.23" />
                      <rect class="cls-lyk1-right" x="3.45" y="8.5" width="3.78" height="8.96" rx="1.88" ry="1.88" />
                    </svg>

                    <!-- <svg *ngIf="feedObject?.like_status == 1 && feed_like_loader==false" width="18px"  viewBox="0 0 16 16"><defs><style>.cls-lyked-right{fill:#28a745;}</style></defs><g id="Layer_3" data-name="Layer 3"><path class="cls-lyked-right" d="M4.53,13.74h.79l.66.7a2.39,2.39,0,0,0,1.73.76l4.34.07a2.1,2.1,0,0,0,2-1.6,1.55,1.55,0,0,0-.12-1s1.57-1.57.52-2.88a1.35,1.35,0,0,0,1-1.37,2.27,2.27,0,0,0-2.28-2.3H10V3.69A3,3,0,0,0,8.15.87L8,.8a.78.78,0,0,0-1.08.72V3.6a1.54,1.54,0,0,1-.2.76l-1,1.73a.52.52,0,0,1-.46.27H4.53"/><path class="cls-lyked-right" d="M2.71,14.63h0A2.19,2.19,0,0,1,.5,12.44v-5a2.2,2.2,0,0,1,4.4,0v5A2.19,2.19,0,0,1,2.71,14.63Zm0-8.69A1.47,1.47,0,0,0,1.23,7.4v5a1.45,1.45,0,0,0,1.45,1.45h0a1.46,1.46,0,0,0,1.46-1.45v-5A1.47,1.47,0,0,0,2.71,5.94Z"/></g></svg> -->

                    {{mls?.languageText?.feed?.key5}}<span *ngIf="mls?.is_lskey_display==1">(feed.key5)</span></span>

                </div>
                <div class="bookmark-modal col-4 text-center">
                  <span class="cursor-pointer">
                    <!-- loader -->
                    <!-- <svg *ngIf="feed_bookmark_loader==true" width="20px"  height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling" style="background: none;"><circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg> -->

                    <svg width="20px" id="Layer_2" data-name="Layer 2" viewBox="0 0 22 22">
                      <defs>
                        <style>
                          .cls-bm-right {
                            fill: none;
                            stroke: #747475;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                          }
                        </style>
                      </defs>
                      <path class="cls-bm-right"
                        d="M16.67,18.5,11,14.2,5.33,18.5V4.41a.91.91,0,0,1,.91-.91h9.52a.91.91,0,0,1,.91.91Z" />
                    </svg>

                    <!-- <svg  width="20px"  id="Layer_ bookmarked" data-name="Layer  bookmarked"  viewBox="0 0 15 15"><defs><style>.cls-bookmarked-right{fill:#28a745;}</style></defs><path class="cls-bookmarked-right" d="M11.54,12.84l-4-3.06-4,3.06v-10a.65.65,0,0,1,.65-.65h6.78a.65.65,0,0,1,.65.65Z"/></svg> -->

                    {{mls?.languageText?.feed?.key6}}<span *ngIf="mls?.is_lskey_display==1">(feed.key6)</span></span>
                </div>
                <div class="share  col-4 text-center">


                  <span class="post-edit-link position-relative"><span class="cursor-pointer">
                      <span><svg id="Layer_3" width="20px" data-name="Layer 3" viewBox="0 0 22 22">
                          <defs>
                            <style>
                              .cls-shr {
                                fill: none;
                                stroke: #747475;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                              }
                            </style>
                          </defs>
                          <path class="cls-shr"
                            d="M12.87,17.51V13.4C7.66,13.4,4.23,15,1.63,18.5c1.05-5,4-10,11.24-11v-4l7.5,7Z" />
                        </svg> {{mls?.languageText?.feed?.key7}}<span
                          *ngIf="mls?.is_lskey_display==1">(feed.key7)</span></span>
                    </span>

                  </span>
                </div>
              </div>
            </div>


            <!-- comment list -->
            <div class="mt-2 border-top p-2 " *ngFor="let comment of feed_detail?.feed_comment_list">
              <div class="clearfix">
                <div class="float-left mr-2 cursor-pointer connection-profile">
                  <div class="position-relative">

                    <div class="position-relative">
                      <img onerror="this.src='assets/img/user_placeholder.svg';"
                        class="c-profile-pic rounded-circle user-40 post-pic "
                        src="{{comment?.user_profile?.profile_pic}}">

                    </div>

                  </div>
                </div>
                <div class="float-left pl-0 d-table w-100 mw-80" style="min-height: 40px;">
                  <div style=" display: table-cell;vertical-align: middle;">
                    <p class="text-capitalize fnt-size14px"><span
                        class="cursor-pointer"><b>{{comment?.user_profile?.full_name}}</b><span
                          class="Accepted_text ml-1"><span class="slash mr-1"></span>

                          <span class="fnt-size12px" *ngFor="let spe of comment?.user_profile?.specialities">
                            {{(spe?.is_primary==1)? spe?.speciality_name:''}}
                          </span>
                        </span>
                      </span>
                    </p>

                    <div class="mt-1 "></div>
                  </div>
                </div>
                <div class="float-right d-table" style="min-height: 40px;">
                  <div style=" display: table-cell;vertical-align: middle;">
                    <p>

                    </p>
                  </div>
                </div>
              </div>


              <div id="commentbox-1" class=" text-left fnt-size14px row mb-3">
                <div class="col-2 pr-0" style="min-width: 64px; max-width: 64px;">
                  <div style="width: 40px;" class="profile-pic mr-2 position-relative">


                  </div>
                </div>

                <div class="col-12 pl-0" style="max-width: calc(100% - 66px);">
                  <div id="comment-1">

                    <!-- comment text -->
                    <div class="modal-cmmnt-bg p-2 rounded mt-2">
                      {{comment?.comment}}
                      <!-- <app-comment-text [cmt]="cL?.comment"></app-comment-text> -->
                    </div>


                    <div class="usc-like fnt-size12px mt-2">
                      <div class="row">
                        <div class="col-6 pr-0">


                          <a class="cursor-pointer">
                            <svg style="margin-top: -4px;" width="13px" viewBox="0 0 16 16">
                              <defs>
                                <style>
                                  .cls-cmmnt-lyk {
                                    fill: #737475;
                                  }
                                </style>
                              </defs>
                              <g id="Layer_3" data-name="Layer 3">
                                <path class="cls-cmmnt-lyk"
                                  d="M4.53,13.74h.79l.66.7a2.39,2.39,0,0,0,1.73.76l4.34.07a2.1,2.1,0,0,0,2-1.6,1.55,1.55,0,0,0-.12-1s1.57-1.57.52-2.88a1.35,1.35,0,0,0,1-1.37,2.27,2.27,0,0,0-2.28-2.3H10V3.69A3,3,0,0,0,8.15.87L8,.8a.78.78,0,0,0-1.08.72V3.6a1.54,1.54,0,0,1-.2.76l-1,1.73a.52.52,0,0,1-.46.27H4.53" />
                                <path class="cls-cmmnt-lyk"
                                  d="M2.71,14.63h0A2.19,2.19,0,0,1,.5,12.44v-5a2.2,2.2,0,0,1,4.4,0v5A2.19,2.19,0,0,1,2.71,14.63Zm0-8.69A1.47,1.47,0,0,0,1.23,7.4v5a1.45,1.45,0,0,0,1.45,1.45h0a1.46,1.46,0,0,0,1.46-1.45v-5A1.47,1.47,0,0,0,2.71,5.94Z" />
                              </g>
                            </svg>

                            <span class="ml-1"> {{mls?.languageText?.feed?.key5}}<span
                                *ngIf="mls?.is_lskey_display==1">(feed.key5)</span></span></a>


                          <a class="cursor-pointer ml-2 mr-2">
                            <svg style="margin-top: -4px;" id="Layer_reply" width="13px" data-name="Layer reply"
                              viewBox="0 0 16 16">
                              <defs>
                                <style>
                                  .cls-reply {
                                    fill: #737475;
                                  }
                                </style>
                              </defs>
                              <path class="cls-reply"
                                d="M12.77,1.18H3.23A2.73,2.73,0,0,0,.5,3.91v6.14a2.72,2.72,0,0,0,2.73,2.72h.68v2.05l2.86-2.05h6a2.72,2.72,0,0,0,2.73-2.72V3.91A2.73,2.73,0,0,0,12.77,1.18ZM4.37,4.81H10A.65.65,0,0,1,10,6.1H4.37a.65.65,0,0,1,0-1.29Zm7.26,4.52H4.37A.65.65,0,0,1,4.37,8h7.26a.65.65,0,0,1,0,1.29Z" />
                            </svg><span class="ml-1"> {{mls?.languageText?.feed?.key8}}<span
                                *ngIf="mls?.is_lskey_display==1">(feed.key8)</span></span></a>
                        </div>


                      </div>

                      <!-- <a class="Acceptopinion_text cursor-pointer">dummy</a> -->

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </span>


          <div *ngIf="feed_detail?.channel?.pharma_classification=='pharma'">
            <h3 class=" text-center mt-4"> {{mls?.languageText?.feed?.key9}}<span
                *ngIf="mls?.is_lskey_display==1">(feed.key9)</span></h3>
          </div>



        </div>

      </div>


      <!-- end -->
    </div>
    <!-- comment box -->
    <div class="mb-2 modal-cmmnt-bg rounded-bottom fnt-size14px p-2">
      <div class="row text-left ml-0">
        <div class="col-2 pr-0 pl-0 mr-2" style="min-width: 40px; max-width: 40px;">
          <div class="profile-pic " style="width: 40px;"><img onerror="this.src='assets/img/user_placeholder.svg';"
              src=""></div>
        </div>
        <div class="col-12 pl-0" style="max-width: calc(100% - 48px);"><input readonly
            class="bg-white w-100 form-control border comment-box-common fnt-size14px" type="text"
            placeholder={{mls?.languageText?.feed?.key10}}> <span *ngIf="mls?.is_lskey_display==1">(feed.key10)</span>
        </div>



      </div>
    </div>

  </div>


</div>
